import VectorLayer from 'ol/layer/Vector';
import {Vector as VectorSource} from 'ol/source.js';

import {Style} from 'ol/style.js';
import Icon from 'ol/style/Icon.js';

import planeURL from './plane.svg?url';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import { fromLonLat } from 'ol/proj';

// https://openskynetwork.github.io/opensky-api/rest.html#response
const fields = [
    "icao24",
    "callsign",
    "origin_country",
    "time_position",
    "last_contact",
    "longitude",
    "latitude",
    "baro_altitude",
    "on_ground",
    "velocity",
    "true_track",
    "vertical_rate",
    "sensors",
    "geo_altitude",
    "squawk",
    "spi",
    "position_source",
    "category",
];
const categories = [
    "No information at all",
    "No ADS-B Emitter Category Information",
    "Light (< 15500 lbs)",
    "Small (15500 to 75000 lbs)",
    "Large (75000 to 300000 lbs)",
    "High Vortex Large (aircraft such as B-757)",
    "Heavy (> 300000 lbs)",
    "High Performance (> 5g acceleration and 400 kts)",
    "Rotorcraft",
    "Glider / sailplane",
    "Lighter-than-air",
    "Parachutist / Skydiver",
    "Ultralight / hang-glider / paraglider",
    "Reserved",
    "Unmanned Aerial Vehicle",
    "Space / Trans-atmospheric vehicle",
    "Surface Vehicle – Emergency Vehicle",
    "Surface Vehicle – Service Vehicle",
    "Point Obstacle (includes tethered balloons)",
    "Cluster Obstacle",
    "Line Obstacle",
];

const vectorLayer = new VectorLayer({
  source: new VectorSource({
    loader: async function() {
      const res = await fetch("https://opensky-network.org/api/states/all");
      const data = await res.json();
      const planes = data.states.map(state =>
        Object.fromEntries(fields.map((f, i) => [f, state[i]]))
      );
      for (let plane of planes) {
        this.addFeature(new Feature({
          geometry: new Point(fromLonLat([plane.longitude, plane.latitude])),
          ...plane,
        }))
      }
    },
  }),
  style: function (feature) {
    return new Style({
      image: new Icon({
        anchor: [0.5, 0.5],
        src: planeURL,
        rotateWithView: true,
        rotation: feature.get("true_track") * Math.PI / 180,
      }),
    });
  },
});

setInterval(() => vectorLayer.getSource().refresh(), 30000);

export default vectorLayer;
